import axios from 'axios';
import config from '../config/api';

const API_BASE_URL = config.endpoints.socias;

export const sociasApiService = {
  // Crear una nueva socia
  async createSocia(formData) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/socias/registrar`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al crear socia:', error);
      throw error;
    }
  },

  // Obtener todas las socias
  async getSocias() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/socias`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener socias:', error);
      throw error;
    }
  },

  // Obtener una socia por ID
  async getSociaById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/socias/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener socia:', error);
      throw error;
    }
  },

  // Actualizar una socia
  async updateSocia(id, formData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/api/socias/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar socia:', error);
      throw error;
    }
  },

  // Eliminar una socia
  async deleteSocia(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/api/socias/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar socia:', error);
      throw error;
    }
  },

  // Obtener permisos de una socia
  async getPermisos(sociaId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/socias/${sociaId}/permisos`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener permisos:', error);
      throw error;
    }
  },

  // Establecer permisos de una socia
  async setPermisos(sociaId, permisos) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/socias/${sociaId}/permisos`, permisos);
      return response.data;
    } catch (error) {
      console.error('Error al establecer permisos:', error);
      throw error;
    }
  },

  // Cambiar estado de una socia (Activo/Inactivo/Fallecida)
  async updateEstado(id, nuevoEstado) {
    try {
      // Usar siempre el endpoint de eliminar para cambiar estado, ya que es más simple y no requiere multipart
      const url = `${API_BASE_URL}/api/socias/${id}/eliminar`;
      const data = { nuevoEstado };
      const response = await axios.put(url, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar estado:', error);
      throw error;
    }
  }
};

export default sociasApiService;
